type monthType = {
  [month: string]: string;
};
export const changeDataFun = (date: string | undefined, flag?: boolean) => {
  if (!date) return undefined;
  const months: monthType = {
    Jan: '1',
    Feb: '2',
    Mar: '3',
    Apr: '4',
    May: '5',
    Jun: '6',
    Jul: '7',
    Aug: '8',
    Sep: '9',
    Oct: '10',
    Nov: '11',
    Dec: '12',
  };

  // 分割日期字串
  let typesOf = '-';
  if (flag) {
    typesOf = ' ';
  } else typesOf = '-';
  const [day, month, year] = date.split(typesOf);

  // 轉換月份
  const monthNumber: string = months[month];

  const dayWithoutZero = parseInt(day, 10);

  // 返回格式化後的日期
  return `${year}年${monthNumber}月${dayWithoutZero}日`;
};
